import './navbar.scss';
import { renderIcons } from "./components/Icons/Icons";
import DefaultNavMenu from "./components/Navbar/DefaultNavMenu";

const DEFAULT_MODAL_LOGOS = [
  '/textures/bagless_logo.png',
  '/textures/bagless_logo.svg',
  '/textures/bagless-premium-logo.png',
  '/textures/logo.png',
  '/textures/image.png',
];

const MODAL_LOGO_SELECTORS = '.modal-background-logo img, .confirm-header-logo';

const isCustomSpaceLogo = (logoSrc = '') => {
  if (!logoSrc || logoSrc.includes('empty.png')) {
    return false;
  }

  return !DEFAULT_MODAL_LOGOS.some((defaultLogo) => logoSrc.includes(defaultLogo));
};

const isDefaultModalLogo = (logoSrc = '') => {
  if (!logoSrc) {
    return true;
  }

  return DEFAULT_MODAL_LOGOS.some((defaultLogo) => logoSrc.includes(defaultLogo));
};

const getCustomSpaceLogo = () => $('.world-top-nav__logo_area__logo img').attr('src');

const applyCustomLogoToModals = (rootElement = document) => {
  const customSpaceLogo = getCustomSpaceLogo();

  if (!isCustomSpaceLogo(customSpaceLogo)) {
    return;
  }

  const root = rootElement instanceof Element ? rootElement : document;
  const logoElements = root.matches?.(MODAL_LOGO_SELECTORS)
    ? [root]
    : Array.from(root.querySelectorAll?.(MODAL_LOGO_SELECTORS) || []);

  logoElements.forEach((logoElement) => {
    if (logoElement.closest('#version-modal')) {
      return;
    }

    const currentSrc = logoElement.getAttribute('src') || '';

    if (isDefaultModalLogo(currentSrc)) {
      logoElement.setAttribute('src', customSpaceLogo);
    }
  });
};

const initNavbar = () => {
  const $trigger = $('#navbar-user-menu');
  if (!$trigger.length) {
    return;
  }

  // Take over from the PHP fallback menu as soon as this bundle runs —
  // do not wait for window.onload (images + rooms/profile bundles).
  window.__defaultNavMenuReady = true;
  $('#main_navbar > #user-menu').removeClass('is-active');

  const navMenu = new DefaultNavMenu();

  navMenu.registerAsMainMenu({
    triggerEl: $trigger,
    position: 'bottom-end',
  })

  $('.modal-background, .modal-close, .close-modal').on('click', () => {
    $('.modal').removeClass('is-active');
  });

  $('#editProfile').on('click', (e) => {
    e.preventDefault();

    console.log('');

    $("#save-profile").addClass("disabled");
    $(".join-guest-header").hide();
    $(".edit-profile-header").css('display', 'flex');
    // $(".edit_profile_holder #save-profile").text($trans('save-text'));
    $(".edit_profile_holder #save-profile").attr("data-lang", "save-text");
    $(".edit_profile_holder").addClass("is-active");
  });

  $('#lang-selector-toggle').on('click', (e) => {
    e.preventDefault();
    $('#lang-selector-menu').toggleClass('lang-selector__menu--active');
  });

  // Add click handler for language options
  $('#lang-selector-menu .lang-selector__option').on('click', (e) => {
    e.preventDefault();
    const language = $(e.currentTarget).data('lang');
    if (language) {
      multiLanguagesController.changeLanguage(language);

      $('.lang-selector__option').removeClass('active');
      $(`.lang-selector__option[data-lang=${language}]`).addClass('active');

      $('#lang-selector-menu').removeClass('lang-selector__menu--active');
    }
  });

  // Close dropdown when clicking outside
  $(document).on('click', (e) => {
    if (!$(e.target).closest('.lang-selector').length) {
      $('#lang-selector-menu').removeClass('lang-selector__menu--active');
    }
    if (!$(e.target).closest('.edit_profile_holder').length) {
      $(".edit_profile_holder").removeClass("is-active");
    }

  });

  renderIcons();

  window.openVersionModal = () => {
    $("#version-modal").addClass("is-active");
    applyCustomLogoToModals();
  };

  applyCustomLogoToModals();

  const modalLogoObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((addedNode) => {
        if (addedNode instanceof Element) {
          applyCustomLogoToModals(addedNode);
        }
      });
    });
  });

  modalLogoObserver.observe(document.body, { childList: true, subtree: true });

  $('#viewInfo').on('click', () => {
    window.openVersionModal();
  })
};

// Run immediately. Do not wait for DOMContentLoaded — that event is blocked
// until deferred rooms/profile bundles (9MB+) finish downloading and parsing.
initNavbar();

